"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissions = exports.checkPermissions = exports.isAdmin = exports.explodePermission = exports.PERMISSION_WILDCARD = void 0;
exports.PERMISSION_WILDCARD = '*';
const explodePermission = (permission) => {
    if (permission === exports.PERMISSION_WILDCARD) {
        return {
            gateway: exports.PERMISSION_WILDCARD,
            path: exports.PERMISSION_WILDCARD,
            action: exports.PERMISSION_WILDCARD,
        };
    }
    const [gateway, rest] = permission.split("::");
    const [path, action] = rest?.split(".") || [];
    return {
        gateway,
        path,
        action,
    };
};
exports.explodePermission = explodePermission;
const isAdmin = (user) => {
    const roles = user.roles || [];
    return roles.some(role => {
        if (typeof role === 'string') {
            return false;
        }
        return role.permissions.includes(exports.PERMISSION_WILDCARD);
    });
};
exports.isAdmin = isAdmin;
const checkPermissions = (user, permissions) => {
    const roles = user.roles || [];
    if ((0, exports.isAdmin)(user)) {
        return true;
    }
    return permissions.every(permission => roles.some(role => {
        if (typeof role === 'string') {
            return false;
        }
        const { gateway, path } = (0, exports.explodePermission)(permission);
        return role.permissions.includes(permission)
            || role.permissions.includes(`${gateway}::${path}.${exports.PERMISSION_WILDCARD}`);
    }));
};
exports.checkPermissions = checkPermissions;
exports.permissions = {
    [exports.PERMISSION_WILDCARD]: "Toutes les permissions",
    'dashboard::auth.login': "Je peux me connecter au dashboard",
    'store::auth.login': "Je peux me connecter au logiciel de caisse",
    'store::delivery-app.access': "Je peux accéder à l'application de livraison",
    // Une permission de connexion par gateway : le dashboard et la caisse en ont chacun une,
    // History reçoit la sienne. Sans elle, un salarié à qui on ne veut donner que la lecture de
    // l'historique devrait recevoir `dashboard::auth.login` — c'est-à-dire la clé d'entrée du
    // back-office complet. Le `path` est `auth`, déjà déclaré dans le `permissionConfiguration`
    // de RoleForm.tsx : la permission est donc immédiatement attribuable depuis l'interface.
    'history::auth.login': "Je peux me connecter à l'historique",
    [`dashboard::shops.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::shops.hubrise-connect": "Je peux connecter un restaurant à Hubrise",
    "dashboard::shops.hubrise-disconnect": "Je peux déconnecter un restaurant de Hubrise",
    "dashboard::shops.create": "Je peux créer un restaurant",
    "dashboard::shops.update": "Je peux mettre à jour un restaurant",
    "dashboard::shops.delete": "Je peux supprimer un restaurant",
    [`dashboard::delivery-zones.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::delivery-zones.create": "Je peux créer une zone de livraison",
    "dashboard::delivery-zones.read": "Je peux consulter les zones de livraison",
    "dashboard::delivery-zones.update": "Je peux mettre à jour une zone de livraison",
    "dashboard::delivery-zones.delete": "Je peux supprimer une zone de livraison",
    [`dashboard::users.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::users.create": "Je peux créer un utilisateur",
    "dashboard::users.read": "Je peux consulter les utilisateurs",
    "dashboard::users.update": "Je peux mettre à jour un utilisateur",
    "dashboard::users.delete": "Je peux supprimer un utilisateur",
    [`dashboard::customers.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::customers.create": "Je peux créer un client",
    "dashboard::customers.read": "Je peux consulter les clients",
    "dashboard::customers.update": "Je peux mettre à jour un client",
    "dashboard::customers.delete": "Je peux supprimer un client",
    "dashboard::customers.export-csv": "Je peux exporter les clients en CSV",
    [`dashboard::catalogs.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::catalogs.publish": "Publier un catalogue",
    "dashboard::catalogs.create": "Je peux créer un catalogue",
    "dashboard::catalogs.read": "Je peux consulter les catalogues",
    "dashboard::catalogs.update": "Je peux mettre à jour un catalogue",
    "dashboard::catalogs.delete": "Je peux supprimer un catalogue",
    [`dashboard::account-codes.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::account-codes.create": "Je peux créer un code comptable",
    "dashboard::account-codes.read": "Je peux consulter les codes comptables",
    "dashboard::account-codes.update": "Je peux mettre à jour un code comptable",
    "dashboard::account-codes.delete": "Je peux supprimer un code comptable",
    [`dashboard::advertisements.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::advertisements.create": "Je peux créer une publicité",
    "dashboard::advertisements.read": "Je peux consulter les publicités",
    "dashboard::advertisements.update": "Je peux mettre à jour une publicité",
    "dashboard::advertisements.delete": "Je peux supprimer une publicité",
    [`dashboard::catalog-snapshots.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::catalog-snapshots.publish": "Je peux re-publier un catalogue",
    "dashboard::catalog-snapshots.preview": "Je peux prévisualiser un catalogue",
    "dashboard::catalog-snapshots.read": "Je peux consulter les publications de catalogue",
    [`dashboard::catalog-snapshot-to-shops.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::catalog-snapshot-to-shops.read": "Je peux consulter les prix du restaurant",
    "dashboard::catalog-snapshot-to-shops.update": "Je peux modifier les prix du restaurant",
    [`dashboard::organizations.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::organizations.hubrise-connect": "Je peux connecter mon organization à Hubrise",
    "dashboard::organizations.read": "Je peux consulter l'organisation",
    "dashboard::organizations.update": "Je peux mettre à jour l'organisation",
    [`dashboard::services.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::services.generate-summary": "Générer un récapitulatif des services",
    "dashboard::services.generate-csv-summary": "Générer un récapitulatif des services au format CSV",
    "dashboard::services.read": "Je peux consulter les services",
    [`dashboard::fiscal.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::fiscal.read": "Je peux consulter la conformité NF525 (caisses, archives, exports)",
    "dashboard::fiscal.manage": "Je peux relancer une archive fiscale ou déclarer une caisse disparue",
    [`dashboard::promotions.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::promotions.create": "Je peux créer une promotion",
    "dashboard::promotions.read": "Je peux consulter les promotions",
    "dashboard::promotions.update": "Je peux mettre à jour une promotion",
    "dashboard::promotions.delete": "Je peux supprimer une promotion",
    [`dashboard::products.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::products.create": "Je peux créer un produit",
    "dashboard::products.read": "Je peux consulter les produits",
    "dashboard::products.update": "Je peux mettre à jour un produit",
    "dashboard::products.delete": "Je peux supprimer un produit",
    [`dashboard::steps.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::steps.create": "Je peux créer une étape",
    "dashboard::steps.read": "Je peux consulter les étapes",
    "dashboard::steps.update": "Je peux mettre à jour une étape",
    "dashboard::steps.delete": "Je peux supprimer une étape",
    [`dashboard::packs.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::packs.create": "Je peux créer un menu",
    "dashboard::packs.read": "Je peux consulter les menus",
    "dashboard::packs.update": "Je peux mettre à jour un menu",
    "dashboard::packs.delete": "Je peux supprimer un menu",
    [`dashboard::payment-methods.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::payment-methods.create": "Je peux créer un moyen de paiement",
    "dashboard::payment-methods.read": "Je peux consulter les moyens de paiement",
    "dashboard::payment-methods.update": "Je peux mettre à jour un moyen de paiement",
    "dashboard::payment-methods.delete": "Je peux supprimer un moyen de paiement",
    [`dashboard::payment-providers.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::payment-providers.create": "Je peux créer un prestataire de paiement",
    "dashboard::payment-providers.read": "Je peux consulter les prestataires de paiement",
    "dashboard::payment-providers.update": "Je peux mettre à jour un prestataire de paiement",
    "dashboard::payment-providers.delete": "Je peux supprimer un prestataire de paiement",
    [`dashboard::tags.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::tags.create": "Je peux créer une catégorie",
    "dashboard::tags.read": "Je peux consulter les catégories",
    "dashboard::tags.update": "Je peux mettre à jour une catégorie",
    "dashboard::tags.delete": "Je peux supprimer une catégorie",
    [`dashboard::taxes.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::taxes.create": "Je peux créer une taxe",
    "dashboard::taxes.read": "Je peux consulter les taxes",
    "dashboard::taxes.update": "Je peux mettre à jour une taxe",
    [`dashboard::options.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::options.create": "Je peux créer une option",
    "dashboard::options.read": "Je peux consulter les options",
    "dashboard::options.update": "Je peux mettre à jour une option",
    "dashboard::options.delete": "Je peux supprimer une option",
    [`dashboard::variations.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::variations.create": "Je peux créer une variation",
    "dashboard::variations.read": "Je peux consulter les variations",
    "dashboard::variations.update": "Je peux mettre à jour une variation",
    "dashboard::variations.delete": "Je peux supprimer une variation",
    [`dashboard::roles.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::roles.create": "Je peux créer un rôle",
    "dashboard::roles.read": "Je peux consulter les rôles",
    "dashboard::roles.update": "Je peux mettre à jour un rôle",
    "dashboard::roles.delete": "Je peux supprimer un rôle",
    [`dashboard::connectors.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::connectors.create": "Je peux créer un connecteur",
    "dashboard::connectors.read": "Je peux consulter les connecteurs",
    "dashboard::connectors.update": "Je peux mettre à jour un connecteur",
    [`dashboard::ingredients.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::ingredients.create": "Je peux créer un ingrédient",
    "dashboard::ingredients.read": "Je peux consulter les ingrédients",
    "dashboard::ingredients.update": "Je peux mettre à jour un ingrédient",
    "dashboard::ingredients.delete": "Je peux supprimer un ingrédient",
    // Distincte de `update` (Maxence, 1er nov. 2026) : un restaurant gère ses
    // ruptures depuis le dashboard sans pouvoir toucher aux fiches des ingrédients.
    "dashboard::ingredients.out-of-stock": "Je peux mettre un ingrédient en rupture",
    [`dashboard::kitchen-areas.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::kitchen-areas.create": "Je peux créer un lieu de fabrication",
    "dashboard::kitchen-areas.read": "Je peux consulter les lieux de fabrication",
    "dashboard::kitchen-areas.update": "Je peux mettre à jour un lieu de fabrication",
    "dashboard::kitchen-areas.delete": "Je peux supprimer un lieu de fabrication",
    [`dashboard::loyalties.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::loyalties.read": "Je peux consulter la configuration fidélité",
    "dashboard::loyalties.update": "Je peux mettre à jour la configuration fidélité",
    [`dashboard::order-cancel-reasons.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::order-cancel-reasons.create": "Je peux créer un motif d'annulation de commande",
    "dashboard::order-cancel-reasons.read": "Je peux consulter les motifs d'annulation de commande",
    "dashboard::order-cancel-reasons.update": "Je peux mettre à jour un motif d'annulation de commande",
    "dashboard::order-cancel-reasons.delete": "Je peux supprimer un motif d'annulation de commande",
    [`dashboard::timesheets.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "dashboard::timesheets.read": "Je peux consulter les pointages",
    "dashboard::timesheets.generate-pdf": "Je peux générer un rapport PDF des pointages",
    [`supply::suppliers.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "supply::suppliers.create": "Je peux créer un fournisseur",
    "supply::suppliers.read": "Je peux consulter les fournisseurs",
    "supply::suppliers.update": "Je peux modifier un fournisseur",
    "supply::suppliers.delete": "Je peux supprimer un fournisseur",
    // `.create`/`.delete` ajoutés en Task 11 fix round 1 : la Task 10 n'avait déclaré que
    // read/update, mais le controller gateway (Task 11) expose bien un CRUD complet sur
    // /supply/supplier-articles (création manuelle + suppression), qui a donc besoin des
    // 4 permissions comme les autres ressources.
    [`supply::supplier-articles.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "supply::supplier-articles.create": "Je peux créer un article fournisseur",
    "supply::supplier-articles.read": "Je peux consulter les articles fournisseur",
    "supply::supplier-articles.update": "Je peux modifier un article fournisseur",
    "supply::supplier-articles.delete": "Je peux supprimer un article fournisseur",
    [`supply::ingredients.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "supply::ingredients.create": "Je peux créer un ingrédient",
    "supply::ingredients.read": "Je peux consulter les ingrédients",
    "supply::ingredients.update": "Je peux mettre à jour un ingrédient",
    "supply::ingredients.delete": "Je peux supprimer un ingrédient",
    [`supply::ingredient-mappings.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "supply::ingredient-mappings.create": "Je peux créer un rapprochement d'ingrédient",
    "supply::ingredient-mappings.read": "Je peux consulter les rapprochements d'ingrédients",
    "supply::ingredient-mappings.update": "Je peux modifier un rapprochement d'ingrédient",
    "supply::ingredient-mappings.delete": "Je peux supprimer un rapprochement d'ingrédient",
    [`supply::recipes.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "supply::recipes.create": "Je peux créer une fiche technique",
    "supply::recipes.read": "Je peux consulter les fiches techniques",
    "supply::recipes.update": "Je peux modifier une fiche technique",
    "supply::recipes.delete": "Je peux supprimer une fiche technique",
    [`supply::price-trends.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "supply::price-trends.read": "Je peux consulter les dérives de prix",
    "supply::document-imports.read": "Je peux consulter les documents fournisseur importés",
    "supply::document-imports.create": "Je peux importer des factures et mercuriales",
    "supply::document-imports.update": "Je peux valider, corriger ou rejeter un document importé",
    "supply::invoices.read": "Je peux consulter les factures fournisseur",
    "supply::ai-credits.read": "Je peux consulter les crédits IA",
    "supply::ai-credits.grant": "Je peux attribuer des crédits IA",
    [`history::services.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    // Le service, pas la journée civile : un service peut courir sur plusieurs jours et une
    // journée en porter deux. C'est l'unité du métier, et le nom de la permission doit dire
    // ce qu'elle ouvre.
    "history::services.read": "Je peux consulter l'historique d'un service",
    "history::orders.read": "Je peux consulter l'historique d'une commande",
    "history::search.read": "Je peux rechercher dans l'historique",
    "history::anomalies.read": "Je peux consulter les anomalies détectées",
    // Distincte de la lecture : archiver retire une anomalie de la liste de travail de TOUTE
    // l'équipe. C'est une décision d'encadrement, pas une préférence d'affichage.
    "history::anomalies.archive": "Je peux archiver et restaurer une anomalie",
    "history::reports.download": "Je peux télécharger un rapport d'historique",
    // FONCTIONS SENSIBLES DE LA CAISSE (NF525 6.13.1.1). La gateway `os` n'est
    // pas une gateway HTTP : c'est le LOGICIEL DE CAISSE lui-même, qui oppose
    // ces permissions dans ses actions (`fiscal-guards.ts`), pas seulement à
    // l'écran. Elles sont attribuables depuis le dashboard comme n'importe
    // quelle autre permission — c'est ce que 6.13.1.1 demande et que
    // l'énumération de rôles codée en dur ne permettait pas.
    [`os::fiscal.${exports.PERMISSION_WILDCARD}`]: "Toutes les permissions",
    "os::fiscal.cloture": "Je peux clôturer la journée sur la caisse (Z)",
    "os::fiscal.annulation": "Je peux annuler un ticket sur la caisse",
    "os::fiscal.correction": "Je peux corriger le règlement d'un ticket encaissé",
    "os::fiscal.retour": "Je peux enregistrer un retour d'article sur la caisse",
    "os::fiscal.ecole": "Je peux activer le mode école (ventes d'entraînement) sur la caisse",
    "os::fiscal.conformite": "Je peux vérifier l'intégrité, exporter le registre et relancer la réplication sur la caisse",
    "os::fiscal.utilisateurs": "Je peux gérer les utilisateurs et leurs rôles depuis la caisse",
    "os::fiscal.caisse": "Je peux changer le rôle de la caisse et du terminal (caisse principale, prise de commande)",
    // Horaires de disponibilité (3 nov. 2026) : le forçage d'un article hors de
    // ses horaires, journalisé au JET 911 avec le responsable qui l'autorise.
    "os::fiscal.hors-creneau": "Je peux ajouter un article en dehors de ses horaires de disponibilité sur la caisse",
};
